import React from 'react';
import cn from 'classnames';

import CN from './DepositSpinner.module.scss';

// DEPRECATED: remove this component and use src/components/generic/Spinner.component.jsx instead
const DepositSpinner = ({ color, message, background }) => (
  <div
    data-bem="DepositSpinner"
    className={cn(CN.depositBackground, CN.loaderBackground)}
    style={{ backgroundColor: background }}
  >
    <div data-bem="DepositSpinner__wrapper" className={CN.depositWrapper}>
      <p data-bem="DepositSpinner__message" className={cn(CN.depositText, CN.loadingText)}>
        {message}
      </p>
      <div data-bem="DepositSpinner__animation" className={cn(CN.depositDepositSpinner, CN.loader, CN.fixed)}>
        <svg className={CN.circular}>
          <circle
            className="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="3"
            strokeMiterlimit="10"
            stroke={color}
          />
        </svg>
      </div>
    </div>
  </div>
);

export default DepositSpinner;
